import { Button } from '@spotted-zebra-uk/ui-components';
import style from './NoSearchResultsTableContent.module.scss';

export const NO_ROLES_MATCH_FILTERS_MESSAGE = 'No roles match these filters.';
export const NO_ROLES_MATCH_FILTERS_DATA_TEST_ID = 'no-roles-match-filters';

const NoRolesMatchFiltersContent = ({
  onResetFilters,
}: {
  onResetFilters: () => void;
}) => (
  <div
    className={style.noSearchResultsContent}
    data-testid={NO_ROLES_MATCH_FILTERS_DATA_TEST_ID}
  >
    <p className={style.noSearchResultsText}>
      {NO_ROLES_MATCH_FILTERS_MESSAGE}
    </p>
    <Button variant="tertiary" size="small" onClick={onResetFilters}>
      Reset all filters
    </Button>
  </div>
);

export default NoRolesMatchFiltersContent;
